import { ChangeEvent, DragEvent, FC, ReactNode, useRef, useState } from 'react';

import { Container, FileInput } from './FileDropzone-styles.ts';

interface FileDropzoneProps {
	onFile: (file: File) => void;
	children?: ReactNode;
	className?: string;
}

export const FileDropzone: FC<FileDropzoneProps> = ({ onFile, children, className }) => {
	const [isDragOver, setIsDragOver] = useState(false);
	const fileInputRef = useRef<HTMLInputElement>(null);

	const handleFile = (file?: File) => {
		file && file.type.match(/^image\/.+/) && onFile(file);
	};

	const onDragEnter = (event: DragEvent) => {
		event.preventDefault();
		setIsDragOver(true);
	};

	const onDragLeave = (event: DragEvent) => {
		event.preventDefault();
		setIsDragOver(false);
	};

	const onDragOver = (event: DragEvent) => {
		event.preventDefault();
	};

	const onDrop = (event: DragEvent) => {
		event.preventDefault();
		setIsDragOver(false);
		handleFile(event.dataTransfer.files[0]);
	};

	const onDropzoneClick = () => fileInputRef.current?.click();

	const onFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
		handleFile(event.target.files?.[0]);
	};

	return (
		<Container
			className={className}
			$isDragOver={isDragOver}
			onClick={onDropzoneClick}
			onDragEnter={onDragEnter}
			onDragLeave={onDragLeave}
			onDragOver={onDragOver}
			onDrop={onDrop}>
			<FileInput ref={fileInputRef} type="file" accept="image/*" hidden onChange={onFileInputChange} />
			{children}
		</Container>
	);
};
